module.exports = __webpack_public_path__ + "11_hair_gold.8193949c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/11_hair_gold.png
// module id = v4Xz
// module chunks = 0